import { useCallback, useState } from 'react';

/**
 * Shared org-unit picker search state for Register / Personal Files.
 * @param {{ searchQuery: object, setSearchQuery: Function, setpageNumber: Function, onApplySearch: (nextSearchQuery: object) => void }} options
 */
export function useOrgUnitSearch({ searchQuery, setSearchQuery, setpageNumber, onApplySearch }) {
    const [showOrgUnitPicker, setShowOrgUnitPicker] = useState(false);
    const [selectedOrgUnitLabel, setSelectedOrgUnitLabel] = useState('');

    const openOrgUnitPicker = useCallback(() => {
        setShowOrgUnitPicker(true);
    }, []);

    const handleOrgUnitPickerCancel = useCallback(() => {
        setShowOrgUnitPicker(false);
    }, []);

    const handleOrgUnitSelect = useCallback(
        (orgUnitId, label) => {
            const displayName = label || '';
            setSelectedOrgUnitLabel(displayName);
            setShowOrgUnitPicker(false);

            const nextSearchQuery = {
                ...(typeof searchQuery === 'object' && searchQuery !== null ? searchQuery : {}),
                orgUnitId: String(orgUnitId),
                orgUnitDisplayName: displayName,
            };
            delete nextSearchQuery.orgUnitName;

            setpageNumber(0);
            setSearchQuery(nextSearchQuery);
            onApplySearch(nextSearchQuery);
        },
        [searchQuery, setSearchQuery, setpageNumber, onApplySearch]
    );

    return {
        showOrgUnitPicker,
        selectedOrgUnitLabel,
        openOrgUnitPicker,
        handleOrgUnitPickerCancel,
        handleOrgUnitSelect,
    };
}
